{
  "headings": {
    "login": "Iniciar sesión",
    "forgotten": "¿He olvidado mi contraseña",
    "confirmation": "Correo electrónico enviado",
    "sending": "Envío de correo electrónico...",
    "setPass": "Configura tu contraseña",
    "startYourFreeTrial": "Inicie su prueba gratuita."
  },
  "subHeadings": {
    "freeTrial": "Prueba gratuita de 30 días. No se requiere tarjeta de crédito.",
    "login": "Para acceder a su cuenta de Iventis, comience por introducir su dirección de correo electrónico.",
    "forgotten": "Introduzca la dirección de correo electrónico vinculada a su cuenta de Iventis y le enviaremos un correo electrónico para restablecer su contraseña.",
    "confirmation": "Compruebe su correo electrónico para ver un enlace para restablecer la contraseña. Puede tardar hasta 10 minutos en llegar.",
    "confirmationCode": "Revisa tu correo electrónico para ver el código de verificación de tu nueva cuenta. Puede tardar hasta 10 minutos en llegar.",
    "setPass": "Ingresa una nueva contraseña para tu cuenta a continuación."
  },
  "labels": {
    "firstName": "Nombre",
    "lastName": "Apellido",
    "projectName": "Nombre del proyecto",
    "email": "Dirección de correo electrónico",
    "password": "Contraseña",
    "confirmPass": "Repite la contraseña",
    "verificationCode": "Código de verificación"
  },
  "placeholders": {
    "email": "Introduce tu dirección de correo electrónico",
    "password": "Introduzca su contraseña",
    "passwordCreate": "Introduzca la contraseña",
    "passwordConfirm": "Vuelva a escribir la contraseña"
  },
  "links": {
    "signIn": "Iniciar sesión",
    "forgotPass": "¿He olvidado mi contraseña",
    "sendAgain": "Enviar de nuevo",
    "termsAndCo": "Términos y condiciones",
    "back": "Atrás",
    "register": "Registrarse",
    "loginWithEmail": "En su lugar, inicie sesión con correo electrónico",
    "loginWithSingleSignOn": "Inicie sesión con inicio de sesión único",
    "loginWithMicrosoft": "Inicia sesión con tu cuenta Microsoft"
  },
  "options": {
    "alreadyHaveAccount": "¿Ya tienes una cuenta de Iventis?",
    "dontHaveAccount": "¿No tienes un {{ ssoProviderName }}",
    "dontHaveIventis": "¿No tienes una cuenta Iventis?",
    "rememberDetails": "¿Recuerdas mis datos",
    "notReceived": "¿No has recibido ningún correo electrónico?",
    "consentTos1": "Al crear esta cuenta, acepto la",
    "consentTos2": "de la plataforma Iventis.",
    "verified": "¡El código se verificó correctamente! Tu cuenta ya está activa."
  },
  "passwordConditions": {
    "min8characters": "Mínimo 8 caracteres",
    "lowercaseLetter": "Contiene una letra minúscula",
    "uppercaseLetter": "Contiene una letra en mayúscula",
    "digit": "Contiene un número"
  },
  "buttons": {
    "continue": "Continuar",
    "login": "Iniciar sesión",
    "sendLink": "Enviar enlace de restablecimiento",
    "createAccount": "Crear cuenta"
  },
  "footer": {
    "terms": "Términos de servicio",
    "policy": "Política de privacidad",
    "contact": "Póngase en contacto con nosotros"
  },
  "error": {
    "invalidCode": "Código no válido.",
    "unknownError": "Algo salió mal",
    "failed": "No se pudo establecer la contraseña. Vuelva a intentarlo.",
    "required": "Obligatorio",
    "invalid": "Dirección de correo electrónico no válida",
    "cantFindEmail": "No podemos encontrar ninguna cuenta de Iventis vinculada a esa dirección de correo electrónico. Vuelva a intentarlo o cree una cuenta.",
    "passwordTooLong": "La contraseña puede tener 64 caracteres como máximo",
    "passwordsMustMatch": "Las contraseñas no coinciden",
    "mustAgreeToTC": "Para crear una cuenta, debes aceptar nuestros términos y condiciones",
    "resetPasswordLinkInvalidTitle": "El enlace ha caducado",
    "resetPasswordLinkInvalid": "El enlace para restablecer la contraseña no es válido o ha caducado. Hemos enviado un nuevo enlace a la dirección de correo electrónico asociada a tu cuenta. Si no recibes un enlace nuevo, prueba a usar el enlace «contraseña olvidada» que aparece a continuación o ponte en contacto con",
    "emailInUse": {
      "0": "Este correo electrónico ya está en uso.",
      "1": "Haga clic aquí",
      "2": "para iniciar sesión"
    }
  }
}